module.exports = __webpack_public_path__ + "static/media/ios-bookmarks.aef6abba.svg";